export default "__VITE_ASSET__CHs$id65__"